// Properties for sale, from our private /api/listings function (see
// functions/listings.js). Only signed-in, allowed accounts get listings.
const LISTINGS_URL = "/api/listings";

const fetchPostcode = async (token, postcode) => {
  const response = await fetch(
    `${LISTINGS_URL}?postcodes=${encodeURIComponent(postcode)}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.error ?? `Listings responded ${response.status}`);
  }
  // Without the function deployed, hosting answers with the app's HTML page
  if (!Array.isArray(body?.listings)) {
    throw new Error("The listings service isn't available yet.");
  }
  return body;
};

// One postcode per request: a busy postcode takes ~30 s to read the first
// time, and Firebase Hosting cuts requests to functions off at 60 s. One
// after another keeps fasteignir.is at browsing pace.
export const fetchListings = async (user, postcodes) => {
  const token = await user.getIdToken();
  const results = [];
  for (const postcode of postcodes) {
    results.push(await fetchPostcode(token, postcode));
  }
  return {
    listings: results.flatMap((r) => r.listings),
    unplaced: results.reduce((sum, r) => sum + r.unplaced, 0),
    fetchedAt: Math.min(...results.map((r) => r.fetchedAt)),
  };
};

// "105, 107 108" -> ["105", "107", "108"]
export const parsePostcodes = (text) => [
  ...new Set(String(text).match(/\b\d{3}\b/g) ?? []),
];

// 79900000 -> "79,9 m.kr."
export const formatPrice = (kr) =>
  kr == null
    ? "Price on request"
    : `${(kr / 1e6).toLocaleString("is-IS", { maximumFractionDigits: 1 })} m.kr.`;

// Thousands of krónur per square metre, the usual Icelandic comparison
export const formatPricePerM2 = ({ price, sizeM2 }) =>
  price && sizeM2
    ? `${Math.round(price / sizeM2 / 1000).toLocaleString("is-IS")} þ.kr./m²`
    : null;
